import { ServerEnv } from '../../shared/sharedTypes/common/misc';
import { UserDictionary } from '../../frontend/scripts/sso/types/UserDictionary';
import { RenderMenuParams } from '../../frontend/scripts/common/components/FFMenuV2/FFMenu';
import { CurrentUser } from '../../frontend/scripts/common/system';

declare global {
    interface Window {
        currentUser?: CurrentUser;
        serverEnv?: ServerEnv;
        featureFlags?: { [key: string]: boolean };
        theme?: string;
        userDict?: UserDictionary;
        timezoneSetting?: string;
        initializedNavMenuState?: RenderMenuParams['initialize']['initializedState'];
        navMenuSizeLocked: RenderMenuParams['initialize']['navMenuSizeLocked'];
    }
}

export function isFeatureEnabled(feature: string) {
    return (
        (window && window.featureFlags && window.featureFlags[feature]) || false
    );
}

export function getAccountUuid(currentUser?: any) {
    const user = currentUser || (window && (window as any).currentUser) || null;
    return user && user.accountUuid;
}

export function hasLicense(
    license: string | RegExp,
    user = (window as any).currentUser
) {
    if (!user) return false;
    if (license instanceof RegExp) {
        return Boolean(
            Object.entries(user).find(
                ([key, value]) => value && license.exec(key)
            )
        );
    } else {
        return Boolean(user[license]);
    }
}
